export const sharedFundStyles = {
  formGroup: {
    marginBlock: '8px'
  },
  errorButton: {
    color: '#FF0000'
  },
  label: {
    fontSize: '14px',
    transform: 'none',
    marginTop: '-4px',
    marginBottom: '3px'
  },
  dataRoomGroup: {
    marginTop: '4px',
    marginBottom: '8px',
    '& .MuiFormGroup-root': {
      marginTop: '6px'
    }
  },
  mainFundGroup: {
    marginTop: '0px',
    marginBottom: '8px',
    width: '100%',
    '& > *': {
      width: '100%'
    }
  }
};
